/* eslint-disable no-param-reassign */
import produce from 'immer';
var secondaryAnalysisFilesLoadingReducer = produce(function (draft, action) {
  var secondaryAnalysisId = action.payload.secondaryAnalysisId;
  draft[secondaryAnalysisId].files.loading = true;
}, {});
export default secondaryAnalysisFilesLoadingReducer;